<template>
  <div
    class="share-buttons"
    :class="{ horizontally: position === 'horizontally' }"
  >
    <a
      :href="facebookShareUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="share"
    >
      <img
        style="cursor: pointer; "
        :src="require('@/assets/newImges/social-icons/f.svg')"
        alt="facebook logo"
    /></a>

    <a
      :href="twitterShareUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="share"
    >
      <img
        style="cursor: pointer; "
        :src="require('@/assets/newImges/social-icons/x.svg')"
        alt="x logo"
    /></a>

    <a
      :href="linkedinShareUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="share"
    >
      <img
        style="cursor: pointer; "
        :src="require('@/assets/newImges/social-icons/in.svg')"
        alt="linkedin logo"
    /></a>

    <span @click="shareNative" class="share">
      <img
        style="cursor: pointer; "
        :src="require('@/assets/newImges/social-icons/link.svg')"
        alt="logo"
      />
    </span>
  </div>
</template>

<script>
export default {
  props: {
    position: {
      type: "horizontally" | "vertically",
      required: false,
      default: "horizontally"
    },
    url: {
      type: String,
      default: () => window.location.href
    },
    title: {
      type: String,
      default: "Check this out!"
    }
  },
  computed: {
    encodedUrl() {
      return encodeURIComponent(this.url);
    },
    encodedTitle() {
      return encodeURIComponent(this.title);
    },
    facebookShareUrl() {
      return `https://www.facebook.com/sharer/sharer.php?u=${this.encodedUrl}`;
    },
    twitterShareUrl() {
      return `https://x.com/intent/tweet?url=${this.encodedUrl}&text=${this.encodedTitle}`;
    },
    linkedinShareUrl() {
      return `https://www.linkedin.com/shareArticle?mini=true&url=${this.encodedUrl}&title=${this.encodedTitle}`;
    }
  },
  methods: {
    shareNative() {
      navigator.clipboard.writeText(this.url);
      this.$toast.success(this.$t("news.copyLink"), {
        duration: 5000
      });
      // if (navigator.share) {
      //   navigator
      //     .share({
      //       title: this.title,
      //       url: this.url,
      //       tag: "eBerza"
      //     })
      //     .catch(err => {
      //       console.error("Sharing failed", err);
      //     });
      // } else {
      //   alert("Web Share API not supported in this browser.");
      // }
    }
  }
};
</script>
<style lang="scss" scoped>
.horizontally {
  display: flex;
}
.share {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: $gray-blue-500;
  width: 60px;
  height: 60px;

  opacity: 1;

  border: 1px solid $gray-blue-700;
  border-radius: 12px;
  margin: 12px;
}
@media only screen and(max-width: 1200px) {
  .share {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $gray-blue-500;
    width: 40px;
    height: 40px;

    opacity: 1;

    border: 1px solid $gray-blue-700;
    border-radius: 12px;
    margin: 5px;
  }
}
@media only screen and(max-width: 768px) {
  .share {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $gray-blue-500;
    width: 35px;
    height: 35px;

    opacity: 1;

    border: 1px solid $gray-blue-700;
    border-radius: 12px;
    margin: 5px;
    img {
      height: 20px;
    }
  }
}
</style>
